import React, { useState } from 'react';
import axios from 'axios';
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
import "./Contact.css"; // Add a separate CSS file for styling
import { FaHotel, FaMailBulk, FaPercentage, FaPhoneAlt } from "react-icons/fa";
import { ImHeadphones } from "react-icons/im";
import { Link } from "react-router-dom";
import { TbPhoneCall } from "react-icons/tb";
import { FaLocationDot } from "react-icons/fa6";
import { toast } from 'react-toastify';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const requestData = {
      Name: formData.firstName,
      LastName: formData.lastName,
      EmailAddress: formData.email,
      Phone: formData.phone,
      Subject: 'Contact Us Enquiry',
      Message: formData.message,
    };

    try {
      const response = await axios.post(
        'https://admin.yatriservice.com/api/ContactEnquiry',
        requestData
      );

      if (response.data.success) {
        setSubmitSuccess(true);
        toast.success("Contact us form submit successfully")
        // Optionally, reset the form
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          message: '',
        });
      } else {
        setSubmitSuccess(false);
      }
    } catch (error) {
      setSubmitSuccess(false);
      console.error('Error submitting the form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="contact_us_content">
      <section className="page-header">
        <div
          className="page-header-bg"
          style={{
            backgroundImage:
              "url('https://img.freepik.com/premium-photo/airplane-wing-clouds-sunset_412311-9717.jpg?w=900')",
          }}
        ></div>
        <div className="container">
          <div className="page-header__inner">
            <h2>Contact us</h2>
            <ul className="thm-breadcrumb list-unstyled">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <span>/</span>
              </li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </section>
      <div className="contentssss">
        <div className="container">
          <div className="row align-items-center row-gap-4">
            <div className="col-xl-7 col-lg-7">
              <div className="mb-4 mb-lg-0">
                <div className="row">
                  <div className="col-md-8">
                    <h2 className="mb-3" style={{ fontWeight: "700" }}>
                      Reach Out to Our Dedicated Support Team
                    </h2>
                  </div>
                </div>
                <div className="mb-4">
                  <h6 className="mb-2">
                    Our team is ready to help. Your satisfaction is our priority
                  </h6>
                  <p style={{ fontSize: "15px" }}>
                    Got a question, need advice, or looking for help? Our
                    knowledgeable team is here to assist you every step of the
                    way. We’re just a message or call away, ready to provide the
                    guidance you need.
                  </p>
                </div>
                <div className="border-bottom mb-4">
                  <div className="d-flex align-items-center mb-4">
                    <span className="avatar avatar-lg rounded-circle bg-light  text-gray-6 me-2">
                      <FaMailBulk
                        className="isax isax-sms5 fs-24"
                        color="#5905bf"
                        size={25}
                      />
                    </span>
                    <div>
                      <p className="fs-14 mb-0">Email Address</p>
                      <h6 className="text-gray-6">support@yatriservice.com</h6>
                    </div>
                  </div>
                </div>
                <div className="border-bottom mb-4">
                  <div className="d-flex align-items-center mb-4">
                    <span className="avatar avatar-lg rounded-circle bg-light  text-gray-6 me-2">
                      <TbPhoneCall
                        className="isax isax-call-calling5 fs-24"
                        color="#5905bf"
                        size={25}
                      />
                    </span>
                    <div>
                      <p className="fs-14 mb-0">Phone Number</p>
                      <h6 className="text-gray-6">+91- 9717039543</h6>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="d-flex align-items-center">
                    <span className="avatar avatar-lg rounded-circle bg-light  text-gray-6 me-2">
                      <FaLocationDot
                        className="isax isax-map-15 fs-24"
                        color="#5905bf"
                        size={25}
                      />
                    </span>
                    <div>
                      <p className="fs-14 mb-0">Our Location</p>
                      <h6 className="text-gray-6">C-8/137 GROUND FLOOR LAWRENCE ROAD KESHAVPURAM NORTH WEST,
                      110035,Delhi</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5">
              <div
                className="card bg-light-200 shadow-none mb-0"
                style={{ padding: "25px" }}
              >
                <div className="card-body">
                  <div className="mb-3">
                    <h2 className="mb-1">Get in Touch</h2>
                    <p className="text-gray-6 mb-1">
                      How we can help you? Please write down your query
                    </p>
                  </div>
                  <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">
                First Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">
                Last Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">
                Phone <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">
                Message <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                rows={3}
                name="message"
                value={formData.message}
                onChange={handleChange}
                style={{ height: '100px' }}
                required
              />
            </div>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          style={{ padding: '8px 14px', fontSize: '14px' }}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
      </form>

      {submitSuccess !== null && (
        <div
          style={{
            marginTop: '20px',
            color: submitSuccess ? 'green' : 'red',
          }}
        >
          {submitSuccess
            ? 'Message sent successfully!'
            : 'Failed to send the message. Please try again.'}
        </div>
      )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
